import classNames from "classnames";
import {Trans} from "../../utils/i18n";
import {formatCurrency} from "../../utils/formatCurrency";
import React from "react";

export default function PriceBadge({ problem2, hidePrice, serviceProduct, style, warranty, requesttype}) {
    if(warranty) {
        return (
            <div className={classNames({
                'bg-secondary-900 text-white md:w-auto px-6 py-3 ': true,
                'w-full rounded-lg': true,
            })}>
                <span className={'block md:font-bold'}><Trans i18nKey={'deviceWidget.warranty'}>Warranty</Trans></span>
                <span className={'hidden md:block text-sm mb-2'}><Trans i18nKey={'deviceWidget.warranty.textBr'}>This service is covered <br/>by the product warranty</Trans></span>
                <span className={'block md:hidden text-sm mb-2'}><Trans i18nKey={'deviceWidget.warranty.text'}>This service is covered by the product warranty</Trans></span>
            </div>
        );
    }

    if(requesttype === 'rma_b2b' || (hidePrice)) {
        return (
            <div className={classNames({
                'bg-secondary-900 text-white md:w-auto px-6 py-3 ': true,
                'w-full rounded-lg': true,
            })}>
                <span className={'block md:font-bold'}><Trans i18nKey={'deviceWidget.oow'}>Out-of-warranty</Trans></span>
                <span className={'hidden md:block text-sm mb-2'}><Trans i18nKey={'deviceWidget.oow.textBr'}>This service is not covered <br/>by the product warranty</Trans></span>
                <span className={'block md:hidden text-sm mb-2'}><Trans i18nKey={'deviceWidget.oow.text'}>This service is not covered by the product warranty</Trans></span>
            </div>
        );
    }

    if(serviceProduct) {
        return (
            <div className={classNames({
                'bg-secondary-900 text-white md:w-auto px-6 py-3 ': true,
                'w-full rounded-lg': style !== 'alternative',
                'w-[calc(100%+6rem)] md:h-[calc(100%_+_3rem)] -mb-6 -mx-6 md:-m-6 md:px-9 md:pt-4 md:pb-3': style === 'alternative',
            })}>
                <span className={'block md:font-bold'}><Trans i18nKey={'deviceWidget.initialInspectionFee'}>Initial Inspection fee</Trans>*</span>
                {
                    style === 'alternative' &&
                    <span className={'hidden md:block text-sm mb-2'}><Trans i18nKey={'deviceWidget.includesPostageBr'}>Includes postage and<br/> inspection</Trans>*</span>
                }
                {
                    style === 'alternative' &&
                    <span className={'block md:hidden text-sm mb-2'}><Trans i18nKey={'deviceWidget.includesPostage'}>Includes postage and inspection</Trans>*</span>
                }
                <p
                    className={classNames({
                        'm-0 p-0 md:text-right font-xl font-bold text-xl': true,
                        'text-right': style === 'alternative',
                    })}
                >
                    { formatCurrency(serviceProduct?.price?.priceGross, serviceProduct?.price?.currency) }
                </p>
            </div>
        );
    }

    if(problem2 && problem2?.price?.priceGross) {
        return (
            <div className={classNames({
                'bg-secondary-900 text-white px-6 py-3 rounded-lg w-64': true,
            })}>
                <span className={'block md:font-bold'}><Trans i18nKey={'common.price'}>Price</Trans></span>
                <p
                    className={classNames({
                        'm-0 p-0 md:text-right font-xl font-bold text-xl': true,
                    })}
                >
                    { formatCurrency(problem2?.price?.priceGross, problem2?.price?.currency) }
                </p>
            </div>
        );
    }

    if(!serviceProduct && warranty === false) {
        return (
            <div className={classNames({
                'bg-secondary-900 text-white md:w-auto px-6 py-3 ': true,
                'w-full rounded-lg': true,
            })}>
                <span className={'block md:font-bold'}><Trans i18nKey={'deviceWidget.oow'}>Out-of-warranty</Trans></span>
                <span className={'hidden md:block text-sm mb-2'}><Trans i18nKey={'deviceWidget.oow.textBr'}>This service is not covered <br/>by the product warranty</Trans></span>
                <span className={'block md:hidden text-sm mb-2'}><Trans i18nKey={'deviceWidget.oow.text'}>This service is not covered by the product warranty</Trans></span>
            </div>
        );
    }

    return (
        <div/>
    )
}
